import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTheme } from "../hooks/useTheme";
import GraphiteLogo from "./GraphiteLogo";
import DarkModeToggle from "./DarkModeToggle";
import { Menu, X } from "lucide-react";

const navLinkClass = (isDarkMode) =>
  `no-underline py-2 px-4 rounded-md transition-all duration-300 ease-in-out font-medium ${
    isDarkMode
      ? "text-gray-200 hover:text-graphite-shine hover:bg-graphite-steel/20"
      : "text-gray-800 hover:text-graphite-steel hover:bg-graphite-steel/10"
  }`;

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[1000] py-4 transition-all duration-300 ease-in-out ${
        isDarkMode
          ? "bg-graphite-darkest/90 border-graphite-medium/30"
          : "bg-white/90 border-gray-200"
      } backdrop-blur-[10px] border-b`}
    >
      <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-20 flex justify-between items-center">
        <GraphiteLogo className="h-10 sm:h-12 w-auto" />

        <nav
          className={`${isMenuOpen ? "flex" : "hidden"} md:flex absolute md:relative top-full md:top-0 left-0 right-0 ${
            isDarkMode
              ? "bg-graphite-darkest md:bg-transparent border-graphite-dark"
              : "bg-white md:bg-transparent border-gray-200"
          } flex-col md:flex-row items-center md:items-center gap-0 md:gap-8 p-6 md:p-0 border-b md:border-b-0`}
        >
          <a href={isHome ? "#home" : "/"} className={navLinkClass(isDarkMode)}>
            Home
          </a>
          <a
            href={isHome ? "#services" : "/#services"}
            className={navLinkClass(isDarkMode)}
          >
            Services
          </a>
          <a
            href={isHome ? "#technologies" : "/#technologies"}
            className={navLinkClass(isDarkMode)}
          >
            Technologies
          </a>

          <a
            href={isHome ? "#contact" : "/#contact"}
            className={navLinkClass(isDarkMode)}
          >
            Contact
          </a>
        </nav>

        <div className="flex items-center gap-4">
          <DarkModeToggle />
          <button
            className={`md:hidden p-2 rounded-lg transition-colors ${
              isDarkMode
                ? "hover:bg-graphite-dark text-gray-200"
                : "hover:bg-gray-100 text-gray-800"
            }`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
